module.exports = __webpack_public_path__ + "images/[13].jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[13].jpeg
// module id = 44
// module chunks = 0